import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@pattern-library/checkbox';
const propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  qaId: PropTypes.string,
  status: PropTypes.oneOf(['disabled']),
  value: PropTypes.bool
};
function CheckboxCell(_ref) {
  let {
    id,
    label = 'Select row',
    onChange,
    qaId,
    status,
    value = false
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "asc-table-component-editable-cell"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    onChange: onChange,
    id: id,
    isChecked: value,
    isDisabled: status === 'disabled',
    label: /*#__PURE__*/React.createElement("span", {
      className: "asc-acc-hidden"
    }, label),
    qaId: qaId
  }));
}
CheckboxCell.propTypes = propTypes;
export default CheckboxCell;